import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { ModalSalesOrderComponent } from 'src/app/components/inventory-modals/modal-sales-order.component';
import { Sale } from 'src/app/models/sale.model';
import { InventoryService } from 'src/app/services/inventory.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-index-sales',
  template: `
    <div class="d-flex mb-4 mt-4">
      <h1>Ventas</h1>
    </div>
    <div class="d-flex">
      <div class="me-3" style="width: 222px !important; min-width: 222px !important;">
        <ul #sidebar app-nav-inventory [currentView]="currentView" class="list-unstyled"></ul>
      </div>
      <div #pages class="flex-fill">
        <div class="d-flex">
          <div>
            <div ngbDropdown class="d-inline-block"> <!-- (click)="datepicker.toggle()" -->
              <button type="button" class="btn btn-zazz-default rounded-4 px-4 shadow-sm" id="dropdownForm1" ngbDropdownToggle>
                <fa-icon [icon]="icons.faCalendarAlt" class="me-2"></fa-icon>
                Este mes
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownForm1" class="shadow" style="width: 650px;">
                <!-- ...existing calendar dropdown content... -->
              </div>
            </div>
          </div>
          <div class="flex-fill">
            <button class="btn btn-zazz-default rounded-4 px-4 ms-2 shadow-sm">
              <fa-icon [icon]="icons.faSliders" class="me-2"></fa-icon>
              Filtrar búsqueda
            </button>
          </div>
          <div class="flex-fill">
            <button 
              class="btn btn-zazz-default rounded-4 px-4 ms-2 shadow-sm" 
              *ngIf="authService.hasPermission('can_create_sales')"
              (click)="openModalSaleOrder()">
              <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>
              Nueva Venta
            </button>
          </div>
          <div class="flex-fill ms-2" [formGroup]="searchForm">
            <input type="text" 
              class="form-control rounded-4 border border-1 border-secondary" 
              placeholder="Buscar ventas" 
              formControlName="search">
          </div>
        </div>
        <div class="d-flex mt-2">
          <div class="flex-fill">
            <div class="list-group rounded-5 shadow mt-4">
              <div class="list-group-item w-100">
                <table class="table table-sm mt-3" style="overflow-x: scroll;">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-left-3 py-2 ps-3">
                        # Venta <button class="btn p-0 text-light"><fa-icon [icon]="icons.faSort"></fa-icon></button>
                      </th>
                      <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Monto Total</th>
                      <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Estado</th>
                      <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Notas</th>
                      <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Fecha</th>
                      <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light rounded-top-right-3 py-2">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr 
                    app-tr-sale
                    [sale]="sale"
                    *ngFor="let sale of filteredSales | paginate: { 
                      itemsPerPage: payload.per_page, 
                      currentPage: p, 
                      totalItems: meta.total_entries 
                    }">
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="list-group-item text-center pt-3">
                <pagination-controls
                  (pageChange)="pageChanged($event)"
                  previousLabel="Prev."
                  nextLabel="Sig."
                  screenReaderPaginationLabel="Pagination"
                  screenReaderPageLabel="page"
                ></pagination-controls>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-modal-sales-order
      (updateDismiss)="loadSales()"
    ></app-modal-sales-order>
  `,
  styleUrls: []
})
export class IndexSalesComponent {
  @ViewChild(ModalSalesOrderComponent, { static: true}) modalSalesOrderComponent !: ModalSalesOrderComponent;

  currentView: string = 'sales';
  sales: Sale[] = [];
  filteredSales: Sale[] = [];
  searchForm: FormGroup;
  meta: any = {};
  p: number = 1;
  payload = {
    page: 1,
    per_page: 10,
    created_at_since: '',
    created_at_to: '',
  };

  constructor(
    private inventoryService: InventoryService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public icons: IconsService,
    public authService: AuthService
  ) {
    this.searchForm = this.fb.group({
      search: ['']
    });

    this.searchForm.get('search')?.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe(searchTerm => {
        this.filterSales(searchTerm);
      });
  }

  ngOnInit() {
    this.loadSales();
  }

  loadSales() {
    this.inventoryService.getSales(this.payload).subscribe({
      next: (response) => {
        this.sales = response.data;
        this.filteredSales = this.sales;
        this.meta = response.meta;
      },
      error: (error) => {
        this.toastr.error('Error loading sales');
      }
    });
  }

  filterSales(searchTerm: string) {
    if (!searchTerm) {
      this.filteredSales = this.sales;
      return;
    }

    searchTerm = searchTerm.toLowerCase();
    this.filteredSales = this.sales.filter(sale => 
      sale.sale_number?.toString().includes(searchTerm) ||
      sale.notes?.toLowerCase().includes(searchTerm)
    );
  }

  openModalSaleOrder() {
    const modalTemplate: any | undefined = this.modalSalesOrderComponent;
    if (modalTemplate) {
      modalTemplate.openModal(modalTemplate['modalSalesOrder']);
    }
  }

  pageChanged(event: number) {
    this.p = event;
    this.payload.page = event;
    this.loadSales();
  }
}
